import React, { createContext, useContext } from "react";
import { createRoot, Root } from "react-dom/client";

import BaseEntity from "./entity/BaseEntity";
import Entity from "./entity/Entity";
import type Game from "./Game";

/** Useful for rendering react to the screen when you want it */
export class ReactEntity extends BaseEntity implements Entity {
  el!: HTMLDivElement;

  reactRoot!: Root;

  constructor(
    public getReactContent: () => React.ReactNode,
    public autoRender = true,
  ) {
    super();
  }

  reactRender() {
    this.reactRoot?.render(
      <GameContext.Provider value={this.game}>
        {this.getReactContent()}
      </GameContext.Provider>,
    );
  }

  onRender() {
    if (this.autoRender) {
      this.reactRender();
    }
  }

  onAdd() {
    this.el = document.createElement("div");
    document.body.append(this.el);
    this.reactRoot = createRoot(this.el);
  }

  onDestroy() {
    if (this.el) {
      this.el.remove();
    }
    if (this.reactRoot) {
      this.reactRoot.unmount();
    }
  }
}

const GameContext = createContext<Game | null | undefined>(null);

export function useGame() {
  const maybeGame = useContext(GameContext);
  if (maybeGame === null) {
    throw new Error("useGame must be used within a GameProvider");
  }
  if (maybeGame === undefined) {
    throw new Error("ReactEntity has no game");
  }
  return maybeGame;
}
